import React from 'react';
import { observer } from 'mobx-react-lite';
import { createMaterialCollapsibleTopTabNavigator } from 'react-native-collapsible-tab-view';
import { styled } from 'dripsy';
import { Animated, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { screens } from './screens';
import type { HomeTabParamListType } from './types';
import { LatestScreen, NewsScreen, MyHubScreen } from '@screens';
import { TopTabBar } from './components/TopTabBar';
import { useVar } from '@hooks';
import { AnimatedValueProvider } from '@context';
import {
  HomeScreenTopBar,
  HOME_SCREEN_TOB_BAR_HEIGHT_RESPONSIVE,
} from './components/HomeScreenTopBar';
import { IS_MOBILE } from '@utils';

const TabNavigator =
  createMaterialCollapsibleTopTabNavigator<HomeTabParamListType>();

const TabBarContainer = styled(View)({
  px: ['$6', '$7', '5%'],
  bg: '$background0',
});

export const HomeTabNavigator = observer(() => {
  const { t } = useTranslation();
  // We are using animatedValue and AnimatedValueContext in order to have
  // the ability to share scrollY outside CollapsibleTabViewContext that we
  // cannot reach in any other way
  // TODO: Maybe we should fork and fix react-native-collapsible-tab-view
  // (useCollapsibleScene should return scrollY)
  const animatedValue = useVar(new Animated.Value(0));

  return (
    <AnimatedValueProvider value={animatedValue}>
      <TabNavigator.Navigator
        initialRouteName={screens.Latest}
        tabBar={(props) => (
          <TabBarContainer>
            <TopTabBar {...props} />
          </TabBarContainer>
        )}
        collapsibleOptions={{
          renderHeader: () => <HomeScreenTopBar />,
          headerHeight: HOME_SCREEN_TOB_BAR_HEIGHT_RESPONSIVE,
          disableSnap: true,
          swipeEnabled: false,
          animatedValue,
          animationEnabled: IS_MOBILE,
        }}
      >
        <TabNavigator.Screen
          name={screens.Latest}
          component={LatestScreen}
          options={{
            title: t('home.latest'),
          }}
        />
        <TabNavigator.Screen
          name={screens.News}
          component={NewsScreen}
          options={{
            title: t('home.news'),
          }}
        />
        <TabNavigator.Screen
          name={screens.MyHub}
          component={MyHubScreen}
          options={{
            title: t('home.myHub'),
          }}
        />
      </TabNavigator.Navigator>
    </AnimatedValueProvider>
  );
});
